<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Dividend Historyg',
          to: {
            name: 'DividendHistory'
          }
        },
        { name: 'Create',
          to: {
            name: 'DividendHistoryCreate',
          },
        },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>新增Dividend History</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <!--  -->
    <DividendHistoryCreateEdit></DividendHistoryCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import DividendHistoryCreateEdit from '@/views/I-4__IR-DividendHistoryCreate/c/DividendHistoryCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    DividendHistoryCreateEdit,
  },
  created() {
    this.setShareholderDividendHistory({});
  },
  computed: {
    ...mapState('shareholderDividendHistory', ['shareholderDividendHistory']),
  },
  methods: {
    ...mapActions('shareholderDividendHistory', ['setShareholderDividendHistory', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'DividendHistory' });
    },
    saveHandler() {
      this.save(this.shareholderDividendHistory).then(() => {
        this.$router.push({ name: 'DividendHistory' });
      });
    },
  },
};
</script>

<style></style>
